import React from "react";
import AlertService from "../../components/SweetAlert";
import ToastUtil from "../../components/ToastNotification/ToastUtil";
import "./styles.css";

const SiteSettings = ({ history, client, sites }) => {
  const default_site_id = localStorage.getItem("default_site_id")
    ? Number(localStorage.getItem("default_site_id"))
    : null;

  const [settingActiveSite, setSettingActiveSite] =
    React.useState(default_site_id);

  const changeActiveSiteHandler = (site_id) => {
    setSettingActiveSite(site_id);
  };

  const saveActiveSiteHandler = async () => {
    if (
      await AlertService.confirm("", `Are you sure you want to change site?`)
    ) {
      settingActiveSite &&
        localStorage.setItem("default_site_id", `${settingActiveSite}`);

      ToastUtil.success("Save site settings successfully!");
    }
  };

  return (
    <div className="site-settings__container">
      <div className="site-settings__navlinks">
        <i
          className="fas fa-arrow-left"
          style={{
            marginTop: 5,
          }}
          onClick={() => {
            history.goBack();
          }}
        />
        <h3>Site Settings</h3>
      </div>
      <div className="py-2 mr-4 ml-4">
        <div className="form-group">
          <label htmlFor="siteSelect" className="font-weight-bold text-muted">
            Client
          </label>
          <p className="text-muted">{client && client.name}</p>
          <label htmlFor="siteSelect" className="font-weight-bold text-muted">
            Site
          </label>
          <select
            className="form-select dropdown"
            id="siteSelect"
            value={settingActiveSite ? settingActiveSite : 0}
            onChange={(e) => changeActiveSiteHandler(e.target.value)}
          >
            {sites &&
              sites.map((site) => (
                <option key={site.id} value={site.id}>
                  {site.name}
                </option>
              ))}
          </select>
        </div>
      </div>
      <div className="m-5">
        <button
          type="button"
          className="btn btn-design btn-brand "
          onClick={() => {
            saveActiveSiteHandler();
          }}
        >
          Save
        </button>
      </div>
    </div>
  );
};

export default SiteSettings;
